import { createRouter, createWebHistory } from 'vue-router'
import DashboardLayout from '../layouts/DashboardLayout.vue'
import DashboardView from '../views/DashboardView.vue'
import ListPage from '../components/page/ListPage.vue'
import CreatePage from '../components/page/CreatePage.vue'
import AuthView from '../components/auth/AuthView.vue'
import LandingPageView from '../views/LandingPageView.vue'
import { setupAuthGuard } from './authGuard'
import DonationsList from '../components/DonationsList.vue'
import WithdrawalsList from '../components/WithdrawalsList.vue'
import PlatformLanding from '../views/platform-landing.vue'

const routes = [
  // ==========================
  // Rotas Públicas do Site
  // ==========================
  {
    path: '/',
    name: 'SiteHome',
    component: PlatformLanding,
    meta: { 
      requiresAuth: false, 
      publicLayout: true 
    }
  },
  {
    path: '/login',
    name: 'login',
    component: AuthView,
    meta: { requiresGuest: true }
  },
  {
    path: '/lp/:slug',
    name: 'LandingPageView',
    component: LandingPageView,
    meta: {
      requiresAuth: false,
      publicLayout: true
    }
  },

  // ==========================
  // Rotas Protegidas por JWT (Painel)
  // ==========================
  {
    path: '/dashboard', // <-- O painel agora responde em /dashboard
    component: DashboardLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '', // Fica: /dashboard
        name: 'home',
        component: DashboardView
      },
      {
        path: 'page', // Fica: /dashboard/page
        name: 'Page',
        component: ListPage
      },
      {
        path: 'new-page', // Fica: /dashboard/new-page
        name: 'CreatePage',
        component: CreatePage
      },
      {
        path: 'edit-landing-page/:id', // Retirei a '/' inicial para respeitar a base /dashboard
        name: 'EditLandingPage',
        component: CreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: 'donation-list', // Fica: /dashboard/donation-list
        name: 'DonationList',
        component: DonationsList
      },
      {
        path: 'withdraw-list', // Fica: /dashboard/withdraw-list
        name: 'WithdrawList',
        component: WithdrawalsList
      },
    ]
  },
  
  // ==========================
  // Fallback (Página não encontrada)
  // ==========================
  {
    path: '/:catchAll(.*)',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

setupAuthGuard(router)

export default router